import { setStorageLanguage, languageIsAvailable } from '@modules/browser'
import { cloneDeep } from 'lodash'
const state = {
  language: '',
  fallback: 'fr',
  authorized: [
    'fr'
  ],
  translations: {
    routes: {
      fr: {},
      pl: {}
    },
    messages: {
      fr: {},
      pl: {}
    }
  }
}

const getters = {
  getLanguage: state => state.language,
  getFallback: state => state.fallback,
  getAuthorized: state => state.authorized,
  getTranslationsRoutes: state => state.translations.routes,
  getTranslationsMessages: state => state.translations.messages
}

const mutations = {
  UPDATE_LANGUAGE: (state, string) => {
    state.language = string
  },
  UPDATE_TRANSLATIONS_ROUTES: (state, object) => {
    state.translations.routes = cloneDeep(object)
  },
  UPDATE_TRANSLATIONS_MESSAGES: (state, object) => {
    state.translations.messages = cloneDeep(object)
  }
}

const actions = {
  updateLanguage: ({ dispatch, commit, getters }, language) => {
    const availability = dispatch('checkAvailability', language)
    const newLanguage = availability ? language : getters.getFallback
    setStorageLanguage(newLanguage)
    commit('UPDATE_LANGUAGE', newLanguage)
  },
  checkAvailability: ({ getters }, language) => {
    return languageIsAvailable(cloneDeep(getters.getAuthorized), language)
  },
  updateTranslationsRoutes: ({ commit }, routes) => {
    commit('UPDATE_TRANSLATIONS_ROUTES', routes)
  },
  updateTranslationsMessages: ({ commit }, messages) => {
    commit('UPDATE_TRANSLATIONS_MESSAGES', messages)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
